module.exports = "/_next/static/images/f39e3f2f6299672681298f52d5d5237f-cards-and-device@0.5x.jpg.webp";